module.exports = __webpack_public_path__ + "img/brazil.3fc8860c.png";